import { IExtendedImageOptions } from '@/core/responsive/image/image.types';
import responsiveImageService from '@/core/responsive/image/responsive-image.service';

function generateCdnUrlWithoutParams(src: string, options: Partial<IExtendedImageOptions>, isProductImage: boolean = false): string {
    const cdnUrls = responsiveImageService.getBaseUrls();
    const cdnUrl = isProductImage ? cdnUrls.cdnProductImages : cdnUrls.cdnAssetImages;

    const version = options.cacheBust ?? 1;
    delete options.cacheBust;

    return `${cdnUrl}/cdn-cgi/image/${src}?v=${version}`;
}

export default generateCdnUrlWithoutParams;
